import { graphql } from "gql";

const MESSAGE_LIST_QUERY = graphql(`
  query MessageList($messageThreadId: ID!) {
    messageList(messageThreadId: $messageThreadId) {
      ...Message
    }
  }
`);

export default MESSAGE_LIST_QUERY;
